import React, { useState, useEffect, useMemo, useCallback } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Modal, ModalFooter, Button, MessageBanner, RadioButton, RadioButtonGroup, TextArea, } from "@folio/stripes/components";
import { EXCLUSION_REASONS, STATUS_LABEL_IDS } from "../../types/enforcement";
import styles from "./ExcludeDialog.module.css";
var EXCLUDABLE_STATUSES = new Set(["CREATED", "OVERDUE", "DAMAGED"]);
export var ExcludeDialog = function (_a) {
    var open = _a.open, onClose = _a.onClose, onSubmit = _a.onSubmit, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b, depositRecords = _a.depositRecords, titleCount = _a.titleCount, _c = _a.noApplicableTitles, noApplicableTitles = _c === void 0 ? false : _c;
    var formatMessage = useIntl().formatMessage;
    var _d = useState(""), reason = _d[0], setReason = _d[1];
    var _e = useState(""), note = _e[0], setNote = _e[1];
    useEffect(function () {
        if (!open) {
            setReason("");
            setNote("");
        }
    }, [open]);
    var isOtherReason = reason === "OTHER";
    var isValid = !noApplicableTitles &&
        reason !== "" &&
        (!isOtherReason || note.trim().length > 0);
    var excludable = useMemo(function () { return depositRecords.filter(function (r) { return EXCLUDABLE_STATUSES.has(r.status); }); }, [depositRecords]);
    var unaffected = useMemo(function () { return depositRecords.filter(function (r) { return !EXCLUDABLE_STATUSES.has(r.status); }); }, [depositRecords]);
    var handleSubmit = useCallback(function () {
        if (reason) {
            onSubmit(reason, note);
        }
    }, [reason, note, onSubmit]);
    var handleClose = useCallback(function () {
        setReason("");
        setNote("");
        onClose();
    }, [onClose]);
    return (React.createElement(Modal, { open: open, label: formatMessage({
            id: "ui-br-legaldeposits.enforcement.exclude.title",
        }), onClose: handleClose, footer: React.createElement(ModalFooter, null,
            React.createElement(Button, { buttonStyle: "primary", onClick: handleSubmit, disabled: !isValid || isLoading }, formatMessage({ id: "ui-br-legaldeposits.button.confirm" })),
            React.createElement(Button, { onClick: handleClose }, formatMessage({ id: "ui-br-legaldeposits.button.cancel" }))) }, noApplicableTitles ? (React.createElement(MessageBanner, { type: "warning" }, formatMessage({
        id: "ui-br-legaldeposits.bulk.validation.noApplicableTitles",
    }))) : (React.createElement(React.Fragment, null,
        React.createElement(MessageBanner, { type: "warning" }, titleCount != null ? (React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.bulk.exclude.summary", values: { count: titleCount } })) : (React.createElement(React.Fragment, null,
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.enforcement.exclude.summary", values: {
                    excludeCount: excludable.length,
                    totalCount: depositRecords.length,
                } }),
            React.createElement("ul", { className: styles.recordList },
                excludable.map(function (r, idx) { return (React.createElement("li", { key: r.id, className: styles.recordExclude },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.enforcement.exclude.recordWillBeExcluded", values: {
                            number: idx + 1,
                            library: r.libraryName,
                            status: formatMessage({
                                id: STATUS_LABEL_IDS[r.status],
                            }),
                        } }))); }),
                unaffected.map(function (r, idx) { return (React.createElement("li", { key: r.id, className: styles.recordUnaffected },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.enforcement.exclude.recordUnaffected", values: {
                            number: idx + 1,
                            library: r.libraryName,
                            status: formatMessage({
                                id: STATUS_LABEL_IDS[r.status],
                            }),
                        } }))); }))))),
        React.createElement(RadioButtonGroup, { label: formatMessage({
                id: "ui-br-legaldeposits.enforcement.exclude.reasonLabel",
            }), value: reason, onChange: function (e) {
                return setReason(e.target.value);
            } }, EXCLUSION_REASONS.map(function (opt) { return (React.createElement(RadioButton, { key: opt.value, label: formatMessage({ id: opt.labelId }), value: opt.value })); })),
        isOtherReason && (React.createElement(TextArea, { label: formatMessage({
                id: "ui-br-legaldeposits.enforcement.exclude.noteLabel",
            }), value: note, onChange: function (e) {
                return setNote(e.target.value);
            }, required: true }))))));
};
